import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let modeCache = null;
export const useAppMode = () => {
  const [mode, setMode] = useState(modeCache);
  useEffect(() => { if (!modeCache) api.get("/app-mode").then((r) => { modeCache = r.data.mode; setMode(modeCache); }).catch(() => {}); }, []);
  return mode;
};
